import React from "react";
import CourierActivityModal from "./courier-activity-modal";
import CourierTable from "./courier-table";

const RoundStopsModal = ({
  round,
  stops = [],
  canManage,
  onClose,
  onAddStop,
  onOptimize,
  onMoveStop,
  onRemoveStop
}) => (
  <CourierActivityModal
    title="Round Stops"
    subtitle={round?.code || "Round"}
    onClose={onClose}
    illustrationAlt="Round stops"
  >
    {canManage && (
      <div className="courier-modal-toolbar">
        <button type="button" className="courier-btn-secondary" onClick={onAddStop}>
          Add Stop
        </button>
        {stops.length > 2 && (
          <button
            type="button"
            className="courier-btn-secondary"
            onClick={onOptimize}
          >
            Optimize Order
          </button>
        )}
      </div>
    )}

    <CourierTable>
      <thead>
        <tr>
          <th>#</th>
          <th>Center</th>
          {canManage && <th>Order</th>}
          {canManage && <th className="act">Actions</th>}
        </tr>
      </thead>
      <tbody>
        {stops.map((s, index) => (
          <tr key={s.id}>
            <td>{s.sequence}</td>
            <td>{s.centerName}</td>
            {canManage && (
              <td className="seq">
                <button
                  type="button"
                  className="courier-move"
                  disabled={index === 0}
                  onClick={() => onMoveStop(index, -1)}
                >
                  ↑
                </button>
                <button
                  type="button"
                  className="courier-move"
                  disabled={index === stops.length - 1}
                  onClick={() => onMoveStop(index, 1)}
                >
                  ↓
                </button>
              </td>
            )}
            {canManage && (
              <td className="act">
                <a
                  title="Remove"
                  className="action icon-cancel"
                  href=" "
                  onClick={e => {
                    e.preventDefault();
                    onRemoveStop(s);
                  }}
                />
              </td>
            )}
          </tr>
        ))}
        {!stops.length && (
          <tr>
            <td colSpan={canManage ? 4 : 2}>No stops yet.</td>
          </tr>
        )}
      </tbody>
    </CourierTable>
  </CourierActivityModal>
);

export default RoundStopsModal;
